import { EuiIcon, EuiPanel, EuiTabbedContent } from "@elastic/eui";
import React, { useEffect } from "react";
import { FormattedMessage } from "react-intl";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { useDispatch, useSelector } from "react-redux";
import { activeTripSelector, fetchTrip } from "modules/trips/slice";
import { extractResourceAttributes } from "utils/jsonApiUtils";
import TripRoute from "../Summary/TripRoute";
import TripLocations from "./TripLocations";
import LiveLocation from "./liveLocation";

const NewTrip = () => {
    const { id } = useParams();
    const dispatch = useDispatch();
    const activeTrip = useSelector(activeTripSelector());
    const trip = extractResourceAttributes(activeTrip);

    useEffect(() => {
        if (id) {
            dispatch(
                fetchTrip(
                    id,
                    "driver,truck,order,supplier,tripPoints,tripPoints.attachments,tripType,truckType,order.branch,confirmedTrips,confirmedTrips.confirmedBy,project"
                )
            );
        }
    }, [dispatch, id]);

    const tabs = [
        {
            id: "trip-route",
            name: (
                <span>
                    <EuiIcon
                        style={{ marginRight: 8, marginTop: -2 }}
                        type="gisApp"
                    />
                    <FormattedMessage id="trip.route-section-title" />
                </span>
            ),
            content: (
                <TripRoute
                    trip={trip && trip.id ? trip : { id }}
                    isRouteEnhanced={false}
                />
            ),
        },
        {
            id: "trip-locations",
            name: (
                <span>
                    <EuiIcon
                        style={{ marginRight: 8, marginTop: -2 }}
                        type="gisApp"
                    />
                    Trip Locations
                </span>
            ),
            content: <TripLocations id={id} />,
        },
        {
            id: "live-locations",
            name: (
                <span>
                    <EuiIcon
                        style={{ marginRight: 8, marginTop: -2 }}
                        type="gisApp"
                    />
                    Live Location
                </span>
            ),
            content: <LiveLocation id={id} />,
        },
    ];

    return (
        <div>
            <EuiPanel style={{ padding: 0 }}>
                <EuiTabbedContent
                    tabs={tabs}
                    expand={false}
                    initialSelectedTab={tabs[0]}
                    autoFocus="selected"
                />
            </EuiPanel>
        </div>
    );
};

export default NewTrip;
